var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{staticStyle:{"background-color":"#eeeeee"},attrs:{"theme":"light"}},[_c('nav-bar-connections'),_c('VMain',[_c('router-view',{staticClass:"secondary--text"})],1),_c('test-error')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }